import { useAtomValue } from 'jotai';
import { IInvestmentDataModel } from '../../../data-models/investment.data-model';
import { roundsByIdMapAtom } from '../../../services/state/AppConfigStateJ';
import { FMT } from '../../../util/formatter-service';
import { useCompanyMapLookup } from '../../../services/hooks/useSaveCompanyData';
import { investmentDataComparator } from '../components/OverviewTable/columns/AggregationConfigs';
import { MostRecentChartData } from './useMostRecentRounds';

export const useMostRecentParticipatingRounds = (data: IInvestmentDataModel[]): MostRecentChartData[] => {
  const uniqueData = new Map<string, MostRecentChartData>();
  const getCompany = useCompanyMapLookup();
  const roundsById = useAtomValue(roundsByIdMapAtom);

  const sortedData = (data ?? [])
    .reduce(
      (res, { companyId, gcAmount, investmentDate, round, roundId }) => {
        const company = getCompany(companyId);
        if (company && gcAmount && investmentDate) {
          res.push({
            company,
            dealLead: company.dealLeadId ? FMT.format('user', company.dealLeadId) : '',
            date: new Date(investmentDate),
            formattedValue: FMT.format('currencyShort', gcAmount),
            investmentDate,
            round,
            roundId,
          });
        }
        return res;
      },
      [] as (MostRecentChartData & { roundId: number | null; investmentDate: string })[]
    )
    .sort((a, b) => {
      return investmentDataComparator(b, a, roundsById);
    });

  for (let i = 0; i < sortedData.length && uniqueData.size < 5; i++) {
    if (!uniqueData.has(sortedData[i].company.name)) {
      uniqueData.set(sortedData[i].company.name, sortedData[i]);
    }
  }

  return Array.from(uniqueData.values());
};
